module.exports = __webpack_public_path__ + "static/media/soc_fb_wBG.96b926ad.svg";